<!-- <app-create-asin-header></app-create-asin-header> -->
<app-top-menu></app-top-menu>
<div class="landing-div" style="{{minHeight}}">
    <div class="container mb-4" style="{{minHeight2}}">
        <div style="padding: 50px 30px;">
            <div class="row">
                <div class="col-md-5">
                    <div style="margin-bottom: 60px">
                        <h4 class="landing-txt-hd mb-3">What is ASIN?</h4>
                        <p class="landing-txt">
                            ASIN stands for Anambra State Identity Number. It is a unique and one-time electronically generated identification number issued to both individual and corporate entities or residents by the Anambra State Government through the Anambra State Internal Revenue Service. Getting your ASIN is an essential requirement needed to access all government services and benefits provided by the Anambra State Government.
                        </p>
                    </div>
                    <div class="mb-4">
                        <h4 class="landing-txt-hd mb-3">How to Obtain your ASIN</h4>
                        <p class="landing-txt">
                            To obtain your unique identity number, you have to complete the enumeration process. Getting enumerated is very easy and just a step away. Click any of the buttons below to begin your enumeration process immediately.
                        </p>
                    </div>
                    <br />
                    
                </div>
                <div class="d-flex gap-2 flex-wrap">
                    <button class="asin-button-corporate" routerLink="/create-asin/individual">Individual ASIN</button>
                    <button class="asin-button-corporate" routerLink="/create-asin/informal">Informal/Enterprise ASIN</button>
                    <button class="asin-button-corporate " routerLink="/create-asin/corporate">Corporate ASIN</button>
                </div>
<!--                <img style="position: absolute;width: 80%;right: 0;top: -100px;z-index: 0" src="assets/create-asin/final-bustop.png" alt="bg" />-->
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>

